import React from "react";
import RegistrationPlate from "../common/RegistrationPlate";
import { formatSekAmount } from "../../lib/format.jsx";



// "The deal" card shown to the buyer once connected: both parties, vehicle type,
// registration plate and price. Shared by the manual join flow and the QR landing;
// mirrors the seller's deal summary. Rows appear only when the value is known.
export default function BuyerDealSummary({ t, sellerName, buyerName, vehicleType, regNo, price, connected = true }) {
  return (
    <section className="overflow-hidden rounded-[13px] border border-ds-rule-edge bg-ds-sheet shadow-[0_1px_3px_rgba(16,30,40,.06)]">
      <div className="flex items-center justify-between gap-3 border-b border-ds-rule-row px-4 pt-4 pb-3 sm:px-5">
        <h2 className="font-ds-serif text-base font-semibold text-ds-ink">{t("seller.saleSummaryTitle")}</h2>
        <span
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12.5px] font-semibold ${
            connected ? "bg-ds-green-bg text-ds-green-deep" : "bg-ds-slate-bg text-ds-slate-fg"
          }`}
        >
          <span
            className={`h-1.5 w-1.5 rounded-full ${connected ? "bg-ds-green-dot" : "bg-ds-slate animate-pulse"}`}
            aria-hidden="true"
          />
          {connected ? t("seller.buyerConnectedStatus") : t("buyer.connectingWait")}
        </span>
      </div>

      <div className="grid divide-y divide-ds-rule-row border-b border-ds-rule-row sm:grid-cols-2 sm:divide-x sm:divide-y-0">
        <div className="min-w-0 px-4 py-3.5 sm:px-5">
          <div className="mb-1.5 flex items-center gap-1.5">
            <span className="ds-role-pill ds-role-pill--seller">{t("role.seller")}</span>
          </div>
          {sellerName && <p className="truncate text-[15px] font-semibold text-ds-ink">{sellerName}</p>}
        </div>
        <div className="min-w-0 px-4 py-3.5 sm:px-5">
          <div className="mb-1.5 flex items-center gap-1.5">
            <span className="ds-role-pill ds-role-pill--buyer">{t("role.buyer")}</span>
            <span className="ds-you-chip">{t("seller.you")}</span>
          </div>
          {buyerName && <p className="truncate text-[15px] font-semibold text-ds-ink">{buyerName}</p>}
        </div>
      </div>

      <div className="divide-y divide-ds-rule-row">
        {vehicleType && (
          <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
            <span className="text-[13px] font-medium text-ds-muted">{t("seller.vehicleType")}</span>
            <span className="text-[15px] font-semibold text-ds-ink">{vehicleType}</span>
          </div>
        )}
        {regNo && (
          <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
            <span className="text-[13px] font-medium text-ds-muted">{t("seller.regNumberLabel")}</span>
            <RegistrationPlate value={regNo} size="row" />
          </div>
        )}
        {price ? (
          <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
            <span className="text-[13px] font-medium text-ds-muted">{t("seller.priceLabel")}</span>
            <span className="text-base font-bold tabular-nums text-ds-ink">{formatSekAmount(price)}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
}
